import { useState } from 'react';

const shares = [
  { key: 'weibo', label: '微博', icon: 'ri-weibo-line' },
  { key: 'wechat', label: '朋友圈', icon: 'ri-wechat-line' },
  { key: 'qq', label: 'QQ', icon: 'ri-qq-line' },
  { key: 'copy', label: '复制链接', icon: 'ri-link' },
];

export default function ShareBar() {
  const [hint, setHint] = useState('');

  const handle = (item: (typeof shares)[number]) => {
    if (item.key === 'copy') {
      setHint('链接已复制（前端演示，未连接真实分享接口）');
    } else {
      setHint(`已模拟分享到${item.label}（前端演示，未连接真实分享接口）`);
    }
    window.setTimeout(() => setHint(''), 2600);
  };

  return (
    <div className="mt-8 pt-6 border-t border-background-200">
      <div className="flex flex-wrap items-center gap-3">
        <span className="text-sm text-foreground-500">分享这篇资讯：</span>
        {shares.map((item) => (
          <button
            key={item.key}
            type="button"
            onClick={() => handle(item)}
            className="inline-flex items-center gap-1.5 px-3.5 py-2 rounded-full border border-background-200 bg-background-50 text-sm text-foreground-700 hover:border-primary-300 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className={item.icon} /> {item.label}
          </button>
        ))}
      </div>
      {hint && (
        <p className="mt-3 text-xs text-accent-600 bg-accent-50 border border-accent-200 rounded-md px-3 py-2 inline-block">
          <i className="ri-information-line mr-1" />
          {hint}
        </p>
      )}
    </div>
  );
}